import React from "react";
import ChatUI from "../components/ChatUI";

const KrishnaChatbot = () => {
  return (
    <div>
      <ChatUI />
    </div>
  );
};

export default KrishnaChatbot;
